import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuoteConfirmationComponent } from './quote-confirmation.component'
import { SpinnerModule } from '@spartacus/storefront'
import { ConfigModule, I18nModule } from '@spartacus/core'
// import { CmsPageGuard } from '@spartacus/storefront';
import { RouterModule } from '@angular/router'
import { environment } from '../../../../../environments/environment'

@NgModule({
  declarations: [QuoteConfirmationComponent],
  imports: [
    CommonModule,
    SpinnerModule,
    I18nModule,
    RouterModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['quoteConfirmation'],
        },
      },
    }),
  ],
})
export class QuoteConfirmationModule {}
